import React from 'react'

import SimpleSpinner from 'components/elements/SimpleSpinner'

import styles from './cornerQuantity.module.scss'

type Props = {
  quantity: number
  loading: boolean
}

const CornerQuantity = ({ quantity, loading }: Props) => {
  return (
    <div className={styles.container}>
      {!loading && <div className={styles.content}>{quantity}</div>}
      {loading && (
        <div className={styles.loader}>
          <SimpleSpinner size="xSmall" />
        </div>
      )}
    </div>
  )
}

export default CornerQuantity
